<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3325_48174)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.56574 0.899902C8.14322 0.899898 7.7776 1.19383 7.68681 1.60648C7.20553 3.79419 6.12138 5.80346 4.55709 7.4068L4.24675 7.7249H1.87461C1.37755 7.7249 0.974609 8.12784 0.974609 8.6249V15.3749C0.974609 15.872 1.37755 16.2749 1.87461 16.2749H4.49892C4.61454 16.3232 4.74146 16.3499 4.87461 16.3499H13.2843C14.3448 16.3499 15.2796 15.6538 15.5836 14.6377L17.1317 9.46274C17.5922 7.92327 16.4392 6.37491 14.8323 6.37491H11.0374L11.3569 4.04296C11.5845 2.38078 10.2927 0.899922 8.61503 0.899902H8.56574ZM3.89961 8.7749V15.2249H2.02461V8.7749H3.89961ZM5.41602 8.2448C7.07783 6.54149 8.24705 4.42172 8.80206 2.11088C9.65903 2.21226 10.2883 3.00145 10.168 3.8801L9.8135 6.46758C9.73328 7.05319 10.1884 7.57491 10.7795 7.57491H14.8323C15.6358 7.57491 16.2123 8.34909 15.982 9.11883L14.4339 14.2938C14.2819 14.8019 13.8145 15.1499 13.2843 15.1499H5.09961V8.56912L5.41602 8.2448Z"
        fill="black"
        fill-opacity="0.54"
      />
    </g>
    <defs>
      <clipPath id="clip0_3325_48174">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {
  data() {
    return {};
  },
};
</script>
